'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsentMessage = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _interpolate = require('helpers/interpolate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes a FormattedMessage style "Hello {name}" and munges it to
// "Hello $name" so it can work with the `interpolate` helper
var makeInterpolatable = function makeInterpolatable(message) {
  return (message || '').replace(/\{([a-zA-Z]+)\}/g, '$$$1');
};

var ConsentMessage = exports.ConsentMessage = function (_PureComponent) {
  (0, _inherits3.default)(ConsentMessage, _PureComponent);

  function ConsentMessage() {
    (0, _classCallCheck3.default)(this, ConsentMessage);
    return (0, _possibleConstructorReturn3.default)(this, (ConsentMessage.__proto__ || (0, _getPrototypeOf2.default)(ConsentMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConsentMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          message = _props.message;

      return _react2.default.createElement(
        'p',
        { className: className },
        (0, _interpolate.interpolateToJsx)(makeInterpolatable(message), {
          $linkCookies: _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: '/privacy#cookies' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.consent.terms', defaultMessage: 'Cookie Policy' })
          ),
          $linkPrivacy: _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: '/privacy' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.consent.privacy', defaultMessage: 'Privacy Policy' })
          ),
          $linkTerms: _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: '/terms' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.consent.cookies', defaultMessage: 'Terms of Use' })
          )
        })
      );
    }
  }]);
  return ConsentMessage;
}(_react.PureComponent);

ConsentMessage.propTypes = {
  className: _propTypes2.default.string,
  message: _propTypes2.default.string.isRequired
};